/*****************************************************************************************************************************************************
 * Revision History
 * 2025-04-10 TBH - Added "activityCartListUrl: ActivityCartListUrl," so "Add more activities" button works.
 * 2025-04-10 TBH - Replaced 'document.location.href = ActivityCartUrl;' when cart empty with 'this.showErrorMesage = "Your cart is empty.";'
 *     (Same as done in cartList) to prevent "dancing" page behavior (page load loop) when cart is empty.
 *****************************************************************************************************************************************************/
import { ActivityCartUrl, ActivityCartListUrl, CartFeeSummaryUrl, CartSummaryUrl, CartProfileUpdateUrl } from "../directives/utilities/urls";
export default function activityCartList() {
    return {
        showSuccessMesage: "",
        enrollmentCartList: [],
        waitlistCartList: [],
        isSubmitting: false,
        message:'',
        showLoader: false,
        headingName:'Activity Cart',
        activityCartListUrl: ActivityCartListUrl,
        nextPageUrl: CartProfileUpdateUrl,
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },
        showRemoveCartList(item) {
            this.selectedItem = item;
            document.getElementById("btnDelete").click();
        },
        removeCartList() {
                var jsonData = JSON.stringify({
                    "UserSessionId": "",
                    "AcademicYear": this.selectedItem.academicYear,
                    "AcademicTerm": this.selectedItem.academicTerm,
                    "AcademicSession": this.selectedItem.academicSession,
                    "SerialId": this.selectedItem.serialId
                });
                this.showLoader = true;

                fetch("/api/Checkout/delete-course-from-cart", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.showSuccessMesage = "Course removed succesfully."
                            window.location.href = ActivityCartUrl;
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
        },
        nextStep() {
        
            this.isSubmitting = true;
            fetch('/api/Checkout/SubmitActivityCart', { "method": "GET" })
                .then(response => {
                    return response.json();
                }).then(login => {
                    this.isSubmitting = false;
                    if (login.isSuccess) {
                        document.location.href = this.nextPageUrl;
                    }
                    else {
                        this.showSuccessMesage = "A problem occured assessing your course selection. Please select 'Continue Registration' or 'Cancel' to retry or cancel your registration.";
                    }

                })
        },
        bindCartList() {
    
            var jsonData = JSON.stringify({
                SessionId: "",
                CartRequestType: "A"
            });
            this.showLoader = true;
            this.waitlistCartList = [];
            this.enrollmentCartList = [];
            fetch("/api/Checkout/cart", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: jsonData,
            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {

                        if (response.cartItems.length > 0) {
                            for (var item = 0; item < response.cartItems.length; item++) {
                                if (response.cartItems[item].actionType == "W") {

                                    this.waitlistCartList.push(response.cartItems[item]);
                                } else {
                                    this.enrollmentCartList.push(response.cartItems[item]);
                                }
                                if (this.waitlistCartList.length > 0 && this.enrollmentCartList.length <= 0) {
                                    this.nextPageUrl = CartProfileUpdateUrl;
                                }
                            }
                        
                            this.showSuccessMesage = "";
                        } else {
                            this.showErrorMesage = "Your cart is empty.";
                        }
                    } else {
                        this.showSuccessMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
        },       
        init() {
            this.bindCartList();
           
        },
    };
}
